module.exports = __webpack_public_path__ + "img/CRUZ-ROJA.a7361a73.png";